import Yup from '_zari/validation/_yup'

import ListaDePaisesConstant from 'constants/listaDePaises'

export const ValidationSchema = Yup.object().shape({
  _idPais: Yup.string().required(),
  direccion: Yup.string()
    .min(5)
    .max(200)
    .required(),
  _idDepartamento: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  }),
  _idProvincia: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  }),
  _idDistrito: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  })
})
